<template>
  <Dialog title="Edit Education post" :show="isOpen" :onClose="onClose">
    <el-form :model="item" label-width="120px" label-position="left" size="small">
      <el-form-item label="Title" required>
        <el-input v-model="item.title" />
      </el-form-item>
      <el-form-item label="Post Type" required>
        <el-select v-model="item.post_type">
          <el-option value="video" label="Video (YouTube)" />
          <el-option value="link" label="Link" />
        </el-select>
      </el-form-item>
      <el-form-item label="Audience" required>
        <el-select v-model="item.audience">
          <el-option value="designers" label="Designers" />
          <el-option value="developers" label="Developers" />
        </el-select>
      </el-form-item>
      <el-form-item label="Thumbnail">
        <img v-if="item.thumb_url" :src="item.thumb_url" height="100px" width="auto" />
        <el-input v-model="item.thumb_url" readonly />
        <el-upload :on-success="onUploadSuccess" :data="data" :headers="headers" accept="image/*" :action="action" :file-list="fileList">
          <el-button size="mini" type="primary">Upload</el-button>
        </el-upload>
        <el-button @click="removeImage" v-if="item.thumb_url" size="mini" type="default">Remove</el-button>
      </el-form-item>
      <el-form-item label="Tag" required>
        <el-input v-model="item.tag" />
      </el-form-item>
      <el-form-item :label="item.post_type === 'video' ? 'YouTube ID' : 'URL'" required>
        <el-input v-model="item.src" @change="modifySrc">
          <template slot="prepend" v-if="item.post_type === 'video'">https://youtu.be/</template>
        </el-input>
        (You may also simply paste short YouTube URL here.)
      </el-form-item>
      <el-form-item label="Published" required>
        <el-switch v-model="item.is_published" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">Save</el-button>
        <el-button @click="onClose()">Cancel</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog';
import axios from 'axios';
import moment from 'moment-timezone';
import { pick, get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      fileList: [],
      data: null
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isOpen: Boolean,
    onClose: Function,
    fields: Array,
  },
  components: {
    Dialog,
  },
  computed: {
    ...mapGetters(['token']),
    headers() {
      return { 'Authorization': 'JWT ' + this.token };
    },
    action() {
      const baseUrl = 'https://api.animaapp.com';
      return `${baseUrl}/v2/uploads/education_posts/${this.item.id}/thumb_url`;
    }
  },
  methods: {
    ...mapActions(['getEducationPosts']),
    onUploadSuccess(response) {
      this.fileList = [];
      this.item.thumb_url = response.public_url;
    },
    async save() {
      try {
        if (!this.item.length) {
          const length = await this.calculateVideoLength(this.item);
          if (length) this.item.length = length;
        }
        const payload = pick(this.item, this.fields);
        await this.$api.put(`/product/education_posts/${this.item.id}`, payload);
        this.$message.success('Saved successfully');
        this.getEducationPosts();
        this.onClose();
      } catch (err) {
        this.$notify.error({
          title: 'Failed saving announcement',
          message: err.message
        });
      }
    },
    async calculateVideoLength({ src: videoId }) {
      try {
        const { data } = await axios.get('https://www.googleapis.com/youtube/v3/videos', {
          params: {
            part: 'contentDetails',
            id: videoId,
            key: process.env.VUE_APP_YOUTUBE_API_KEY
          }
        });
        const isoLength = get(data, ['items', '0', 'contentDetails', 'duration']);
        const duration = moment.utc(moment.duration(isoLength).as('milliseconds')).format('m:ss');
        return `${duration} min`
      } catch (err) {
        return null;
      }
    },
    async removeImage() {
      try {
        const payload = { image_url: null };
        await this.$api.put(`/product/announcements/${this.item.id}`, payload);
        this.item.image_url = null;
        this.$message.info('Removed image successfully');
      } catch (err) {
        this.$notify.error({
          title: 'Failed removing image',
          message: err.message
        });
      }
    },
    modifySrc() {
      this.item.src = this.item.src
        .replace(new RegExp(/https?:\/\/youtu\.be\//i), '')
        .replace(new RegExp(/https?:\/\/www?\.youtube\.com\/watch\?v=/i, ''))
        .trim();
      this.item.length = null;
    }
  }
}
</script>